import { render, staticRenderFns } from "./NovaSolicitacaoAutorizacao.vue?vue&type=template&id=ec6a9d14&scoped=true&"
import script from "./NovaSolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
export * from "./NovaSolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
import style0 from "./NovaSolicitacaoAutorizacao.vue?vue&type=style&index=0&id=ec6a9d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6a9d14",
  null
  
)

export default component.exports